import * as React from "react";

const CrossReference: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 106.84 82.32"><path d="M.28,59.74,25.34,38.5v9.93H71.2V71H25.42v10.1c-.94-.76-1.55-1.25-2.15-1.76Q12.43,70.11,1.58,60.9a10.86,10.86,0,0,0-1.3-.81Z" /><path d="M106.42,26.83q-7.1,5.94-14.2,11.9c-3.51,3-7,6-10.83,9.2V37.21H35.47V14.75H81.3V5.46c.69.5,1.11.78,1.49,1.1q10.9,9.27,21.82,18.54c.58.49,1.21.92,1.81,1.37Z" /></svg>
    );
};

export default React.memo(CrossReference);